<!-- src/shared/components/icons/sprites/HeroiconsSprites.vue -->

<!--
  Name:  Icon from HeroIcons by Refactoring UI Inc
  License: MIT
  Source: https://github.com/tailwindlabs/heroicons/blob/d84ffa5/LICENSE

  Usage:
      <svg>
        <use href="#heroicons-outline-eye-off"></use>
      </svg>
-->
<template>
  <svg style="display: block">
    <defs>
      <symbol viewBox="0 0 24 24" id="heroicons-finger-print"><path fill="none"
stroke="currentColor"
stroke-linecap="round"
stroke-linejoin="round"
stroke-width="1.5"
d="M7.864 4.243A7.5 7.5 0 0 1 19.5 10.5c0 2.92-.556 5.709-1.568 8.269M5.742 6.364A7.47 7.47 0 0 0 4.5 10.5a7.46 7.46 0 0 1-1.15 3.993m1.989 3.559A11.2 11.2 0 0 0 8.25 10.5a3.75 3.75 0 1 1 7.5 0q0 .79-.064 1.565M12 10.5a14.94 14.94 0 0 1-3.6 9.75m6.633-4.596a18.7 18.7 0 0 1-2.485 5.33" /></symbol>
      <symbol viewBox="0 0 24 24" id="heroicons-finger-print-solid"><path fill="currentColor"
fill-rule="evenodd"
d="M12 3.75a6.7 6.7 0 0 0-3.722 1.118a.75.75 0 1 1-.828-1.25a8.25 8.25 0 0 1 12.8 6.883a23.2 23.2 0 0 1-1.62 8.543a.75.75 0 0 1-1.395-.551A21.7 21.7 0 0 0 18.75 10.5A6.75 6.75 0 0 0 12 3.75M6.157 5.739a.75.75 0 0 1 .21 1.04A6.7 6.7 0 0 0 5.25 10.5c0 1.613-.463 3.12-1.265 4.393a.75.75 0 0 1-1.27-.8A6.7 6.7 0 0 0 3.75 10.5c0-1.68.503-3.246 1.367-4.55a.75.75 0 0 1 1.04-.211M12 7.5a3 3 0 0 0-3 3c0 3.1-1.176 5.927-3.105 8.056a.75.75 0 1 1-1.112-1.008A10.46 10.46 0 0 0 7.5 10.5a4.5 4.5 0 1 1 9 0q0 .821-.067 1.626a.75.75 0 0 1-1.495-.123Q15 11.26 15 10.5a3 3 0 0 0-3-3m0 2.25a.75.75 0 0 1 .75.75a15.7 15.7 0 0 1-3.781 10.238a.75.75 0 0 1-1.14-.975A14.2 14.2 0 0 0 11.25 10.5a.75.75 0 0 1 .75-.75m3.239 5.183a.75.75 0 0 1 .515.927a19.4 19.4 0 0 1-2.585 5.544a.75.75 0 0 1-1.243-.84a17.9 17.9 0 0 0 2.386-5.116a.75.75 0 0 1 .927-.515"
clip-rule="evenodd" /></symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-paper-airplane-solid">
        <path
          fill="currentColor"
          d="M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94a60.5 60.5 0 0 0 18.445-8.986a.75.75 0 0 0 0-1.218A60.5 60.5 0 0 0 3.478 2.404" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-paper-airplane">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M6 12L3.269 3.125A59.8 59.8 0 0 1 21.486 12a59.8 59.8 0 0 1-18.217 8.875zm0 0h7.5" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        id="heroicons-arrow-trending-down">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M2.25 6 9 12.75l4.286-4.286a11.948 11.948 0 0 1 4.306 6.43l.776 2.898m0 0 3.182-5.511m-3.182 5.51-5.511-3.181" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-trending-down-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M1.72 5.47a.75.75 0 0 1 1.06 0L9 11.69l3.756-3.756a.75.75 0 0 1 .985-.066a12.7 12.7 0 0 1 4.575 6.832l.308 1.149l2.277-3.943a.75.75 0 1 1 1.299.75l-3.182 5.51a.75.75 0 0 1-1.025.275l-5.511-3.181a.75.75 0 0 1 .75-1.3l3.943 2.277l-.308-1.149a11.2 11.2 0 0 0-3.528-5.617l-3.809 3.81a.75.75 0 0 1-1.06 0L1.72 6.53a.75.75 0 0 1 0-1.061"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        id="heroicons-arrow-trending-up">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-trending-up-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M15.22 6.268a.75.75 0 0 1 .968-.431l5.942 2.28a.75.75 0 0 1 .431.97l-2.28 5.94a.75.75 0 1 1-1.4-.537l1.63-4.251l-1.086.484a11.2 11.2 0 0 0-5.45 5.173a.75.75 0 0 1-1.199.19L9 12.312l-6.22 6.22a.75.75 0 0 1-1.06-1.061l6.75-6.75a.75.75 0 0 1 1.06 0l3.606 3.606a12.7 12.7 0 0 1 5.68-4.974l1.086-.483l-4.251-1.632a.75.75 0 0 1-.432-.97"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-x-circle">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-x-circle-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-no-symbol">
        <!-- Prohibition/ban sign - reserved for destructive actions only -->
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-no-symbol-solid">
        <!-- Prohibition/ban sign (solid) - reserved for destructive actions only -->
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m4.28 5.47a.75.75 0 0 1 0 1.06l-9.5 9.5a.75.75 0 1 1-1.06-1.06l9.5-9.5a.75.75 0 0 1 1.06 0"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-user-circle">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M17.982 18.725A7.49 7.49 0 0 0 12 15.75a7.49 7.49 0 0 0-5.982 2.975m11.964 0a9 9 0 1 0-11.963 0m11.962 0A8.97 8.97 0 0 1 12 21a8.97 8.97 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0a3 3 0 0 1 6 0" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-user-circle-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M18.685 19.097A9.72 9.72 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.72 9.72 0 0 0 3.065 7.097A9.72 9.72 0 0 0 12 21.75a9.72 9.72 0 0 0 6.685-2.653m-12.54-1.285A7.49 7.49 0 0 1 12 15a7.49 7.49 0 0 1 5.855 2.812A8.22 8.22 0 0 1 12 20.25a8.22 8.22 0 0 1-5.855-2.438M15.75 9a3.75 3.75 0 1 1-7.5 0a3.75 3.75 0 0 1 7.5 0"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-building-storefront">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3 3 0 0 0 3.75-.615A3 3 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a3 3 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015q.062.07.128.136a3 3 0 0 0 3.622.478m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-building-office">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-building-office-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M3.75 2a.75.75 0 0 0 0 1.5H4v9h-.25a.75.75 0 0 0 0 1.5H6a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 1 7 10h2a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h2.25a.75.75 0 0 0 0-1.5H12v-9h.25a.75.75 0 0 0 0-1.5zM6.5 4a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 .5.5H7a.5.5 0 0 0 .5-.5v-.5A.5.5 0 0 0 7 4zM6 7a.5.5 0 0 1 .5-.5H7a.5.5 0 0 1 .5.5v.5A.5.5 0 0 1 7 8h-.5a.5.5 0 0 1-.5-.5zm3-3a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 .5.5h.5A.5.5 0 0 0 10 5v-.5a.5.5 0 0 0-.5-.5zm-.5 3a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H9a.5.5 0 0 1-.5-.5z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-building-storefront-16-solid">
        <path
          fill="currentColor"
          d="M4.5 7c.681 0 1.3-.273 1.75-.715C6.7 6.727 7.319 7 8 7s1.3-.273 1.75-.715A2.5 2.5 0 1 0 11.5 2h-7a2.5 2.5 0 0 0 0 5m1.75 1.097A4 4 0 0 1 4.5 8.5A4 4 0 0 1 3 8.21v4.29h-.25a.75.75 0 0 0 0 1.5h.5a1 1 0 0 0 .138-.013A.5.5 0 0 0 3.5 14H6a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 1 7 10h2a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h2.5a.5.5 0 0 0 .112-.013q.067.013.138.013h.5a.75.75 0 1 0 0-1.5H13V8.21a4 4 0 0 1-1.5.29a4 4 0 0 1-1.75-.403A4 4 0 0 1 8 8.5a4 4 0 0 1-1.75-.403" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-beaker">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104q-.376.034-.75.082m.75-.082a24.3 24.3 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104q.377.034.75.082M19.8 15.3l-1.57.393A9.07 9.07 0 0 1 12 15a9.07 9.07 0 0 0-6.23-.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.3 48.3 0 0 1 12 21a48 48 0 0 1-8.135-.687c-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-beaker-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M10.5 3.798v5.02a3 3 0 0 1-.879 2.121l-2.377 2.377a9.85 9.85 0 0 1 5.091 1.013a8.3 8.3 0 0 0 5.713.636l.285-.071l-3.954-3.955a3 3 0 0 1-.879-2.121v-5.02a24 24 0 0 0-3 0m4.5.138a.75.75 0 0 0 .093-1.495A25 25 0 0 0 12 2.25a25 25 0 0 0-3.093.191A.75.75 0 0 0 9 3.936v4.882a1.5 1.5 0 0 1-.44 1.06l-6.293 6.294c-1.62 1.621-.903 4.475 1.471 4.88c2.686.46 5.447.698 8.262.698s5.576-.239 8.262-.697c2.374-.406 3.092-3.26 1.47-4.881L15.44 9.879A1.5 1.5 0 0 1 15 8.818z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-beaker-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8.5 3.528v4.644c0 .729-.29 1.428-.805 1.944l-1.217 1.217a8.75 8.75 0 0 1 3.55.62l.502.201a7.25 7.25 0 0 0 4.178.365l-2.403-2.403a2.75 2.75 0 0 1-.805-1.944V3.528a40 40 0 0 0-3 0m4.5.084l.19.015a.75.75 0 1 0 .12-1.495a41.4 41.4 0 0 0-6.62 0a.75.75 0 0 0 .12 1.495L7 3.612v4.56c0 .331-.132.649-.366.883L2.6 13.09c-1.496 1.496-.817 4.15 1.403 4.475C5.961 17.853 7.963 18 10 18s4.039-.148 5.997-.436c2.22-.325 2.9-2.979 1.403-4.475l-4.034-4.034A1.25 1.25 0 0 1 13 8.172z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-credit-card">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-credit-card-solid">
        <g fill="currentColor">
          <path d="M4.5 3.75a3 3 0 0 0-3 3v.75h21v-.75a3 3 0 0 0-3-3z" />
          <path
            fill-rule="evenodd"
            d="M22.5 9.75h-21v7.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3zm-18 3.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75m.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5z"
            clip-rule="evenodd" />
        </g>
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-home">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m2.25 12l8.955-8.955a1.124 1.124 0 0 1 1.59 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-map-pin">
        <g
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5">
          <path d="M15 10.5a3 3 0 1 1-6 0a3 3 0 0 1 6 0" />
          <path d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0" />
        </g>
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-light-bulb">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M12 18v-5.25m0 0a6 6 0 0 0 1.5-.189m-1.5.189a6 6 0 0 1-1.5-.189m3.75 7.478a12.1 12.1 0 0 1-4.5 0m3.75 2.383a14.4 14.4 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-adjustments-horizontal-solid">
        <path
          fill="currentColor"
          d="M18.75 12.75h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5M12 6a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 6m0 12a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 18M3.75 6.75h1.5a.75.75 0 1 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5m1.5 12h-1.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5M3 12a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 12m6-8.25a2.25 2.25 0 1 0 0 4.5a2.25 2.25 0 0 0 0-4.5M12.75 12a2.25 2.25 0 1 1 4.5 0a2.25 2.25 0 0 1-4.5 0M9 15.75a2.25 2.25 0 1 0 0 4.5a2.25 2.25 0 0 0 0-4.5" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-code-bracket">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-computer-desktop-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M2.25 5.25a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3V15a3 3 0 0 1-3 3h-3v.257c0 .597.237 1.17.659 1.591l.621.622a.75.75 0 0 1-.53 1.28h-9a.75.75 0 0 1-.53-1.28l.621-.622a2.25 2.25 0 0 0 .659-1.59V18h-3a3 3 0 0 1-3-3zm1.5 0v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-user">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M15.75 6a3.75 3.75 0 1 1-7.5 0a3.75 3.75 0 0 1 7.5 0M4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.9 17.9 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-user-minus">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M22 10.5h-6m-2.25-4.125a3.375 3.375 0 1 1-6.75 0a3.375 3.375 0 0 1 6.75 0M4 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.3 12.3 0 0 1 10.374 21C8.043 21 5.862 20.355 4 19.234" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-user-minus-solid">
        <path
          fill="currentColor"
          d="M10.375 2.25a4.125 4.125 0 1 0 0 8.25a4.125 4.125 0 0 0 0-8.25m0 9.75a7.125 7.125 0 0 0-7.124 7.247a.75.75 0 0 0 .363.63a13.07 13.07 0 0 0 6.761 1.873c2.472 0 4.786-.684 6.76-1.873a.75.75 0 0 0 .364-.63l.001-.12v-.002A7.125 7.125 0 0 0 10.375 12M16 9.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-user-plus">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0a3.375 3.375 0 0 1 6.75 0M3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.3 12.3 0 0 1 9.374 21C7.043 21 4.862 20.355 3 19.234" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-user-plus-solid">
        <path
          fill="currentColor"
          d="M5.25 6.375a4.125 4.125 0 1 1 8.25 0a4.125 4.125 0 0 1-8.25 0m-3 12.75a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63a13.07 13.07 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63zM18.75 7.5a.75.75 0 0 0-1.5 0v2.25H15a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-2.25H21a.75.75 0 0 0 0-1.5h-2.25z" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-users">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M15 19.128a9.4 9.4 0 0 0 2.625.372a9.3 9.3 0 0 0 4.121-.952q.004-.086.004-.173a4.125 4.125 0 0 0-7.536-2.32M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.3 12.3 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0a3.375 3.375 0 0 1 6.75 0m8.25 2.25a2.625 2.625 0 1 1-5.25 0a2.625 2.625 0 0 1 5.25 0" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-users-solid">
        <path
          fill="currentColor"
          d="M4.5 6.375a4.125 4.125 0 1 1 8.25 0a4.125 4.125 0 0 1-8.25 0m9.75 2.25a3.375 3.375 0 1 1 6.75 0a3.375 3.375 0 0 1-6.75 0M1.5 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63a13.07 13.07 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63zm15.75.003l-.001.144a2.25 2.25 0 0 1-.233.96q.302.018.609.018c1.596 0 3.107-.37 4.451-1.029a.75.75 0 0 0 .42-.642l.004-.204a4.875 4.875 0 0 0-6.961-4.407a8.6 8.6 0 0 1 1.71 5.157z" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-x-mark-16-solid">
        <path
          fill="currentColor"
          d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94z" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-arrow-path">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M13.836 2.477a.75.75 0 0 1 .75.75v3.182a.75.75 0 0 1-.75.75h-3.182a.75.75 0 0 1 0-1.5h1.37l-.84-.841a4.5 4.5 0 0 0-7.08.932a.75.75 0 0 1-1.3-.75a6 6 0 0 1 9.44-1.242l.842.84V3.227a.75.75 0 0 1 .75-.75m-.911 7.5A.75.75 0 0 1 13.199 11a6 6 0 0 1-9.44 1.241l-.84-.84v1.371a.75.75 0 0 1-1.5 0V9.591a.75.75 0 0 1 .75-.75H5.35a.75.75 0 0 1 0 1.5H3.98l.841.841a4.5 4.5 0 0 0 7.08-.932a.75.75 0 0 1 1.025-.273"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-signal">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M9.348 14.652a3.75 3.75 0 0 1 0-5.304m5.304 0a3.75 3.75 0 0 1 0 5.304m-7.425 2.121a6.75 6.75 0 0 1 0-9.546m9.546 0a6.75 6.75 0 0 1 0 9.546M5.106 18.894c-3.808-3.807-3.808-9.98 0-13.788m13.788 0c3.808 3.807 3.808 9.98 0 13.788M12 12h.008v.008H12V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-arrow-down">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8 2a.75.75 0 0 1 .75.75v8.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.22 3.22V2.75A.75.75 0 0 1 8 2"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-arrow-up">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8 14a.75.75 0 0 1-.75-.75V4.56L4.03 7.78a.75.75 0 0 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06L8.75 4.56v8.69A.75.75 0 0 1 8 14"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-up-circle">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-down-circle">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m9 12.75l3 3m0 0l3-3m-3 3v-7.5M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-arrow-right">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M2 8a.75.75 0 0 1 .75-.75h8.69L8.22 4.03a.75.75 0 0 1 1.06-1.06l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06l3.22-3.22H2.75A.75.75 0 0 1 2 8"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-arrow-left">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M14 8a.75.75 0 0 1-.75.75H4.56l3.22 3.22a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 1.06L4.56 7.25h8.69A.75.75 0 0 1 14 8"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-uturn-left">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-top-right-on-square">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-rectangle-group">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 0 1-1.125-1.125zm12 1.5c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125zm-10.5 7.5c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125z" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-rectangle-group-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M1.5 7.125c0-1.036.84-1.875 1.875-1.875h6c1.036 0 1.875.84 1.875 1.875v3.75c0 1.036-.84 1.875-1.875 1.875h-6A1.875 1.875 0 0 1 1.5 10.875zm12 1.5c0-1.036.84-1.875 1.875-1.875h5.25c1.035 0 1.875.84 1.875 1.875v8.25c0 1.035-.84 1.875-1.875 1.875h-5.25a1.875 1.875 0 0 1-1.875-1.875zM3 16.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875v2.25c0 1.035-.84 1.875-1.875 1.875h-5.25A1.875 1.875 0 0 1 3 18.375z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-rectangle-stack">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M6 6.878V6a2.25 2.25 0 0 1 2.25-2.25h7.5A2.25 2.25 0 0 1 18 6v.878m-12 0q.354-.126.75-.128h10.5q.396.002.75.128m-12 0A2.25 2.25 0 0 0 4.5 9v.878m13.5-3A2.25 2.25 0 0 1 19.5 9v.878m0 0a2.3 2.3 0 0 0-.75-.128H5.25q-.396.002-.75.128m15 0A2.25 2.25 0 0 1 21 12v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6c0-.98.626-1.813 1.5-2.122" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-rectangle-stack-solid">
        <path
          fill="currentColor"
          d="M5.566 4.657A4.5 4.5 0 0 1 6.75 4.5h10.5q.616.002 1.183.157A3 3 0 0 0 15.75 3h-7.5a3 3 0 0 0-2.684 1.657M2.25 12a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3zm3-4.5q-.616.002-1.184.157A3 3 0 0 1 6.75 6h10.5a3 3 0 0 1 2.683 1.657A4.5 4.5 0 0 0 18.75 7.5z" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-clock-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-clock">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0a9 9 0 0 1 18 0" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-key-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M15.75 1.5a6.75 6.75 0 0 0-6.651 7.906c.067.39-.032.717-.221.906l-6.5 6.499a3 3 0 0 0-.878 2.121v2.818c0 .414.336.75.75.75H6a.75.75 0 0 0 .75-.75v-1.5h1.5A.75.75 0 0 0 9 19.5V18h1.5a.75.75 0 0 0 .53-.22l2.658-2.658c.19-.189.517-.288.906-.22A6.75 6.75 0 1 0 15.75 1.5m0 3a.75.75 0 0 0 0 1.5A2.25 2.25 0 0 1 18 8.25a.75.75 0 0 0 1.5 0a3.75 3.75 0 0 0-3.75-3.75"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-link-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M19.902 4.098a3.75 3.75 0 0 0-5.304 0l-4.5 4.5a3.75 3.75 0 0 0 1.035 6.037a.75.75 0 0 1-.646 1.353a5.25 5.25 0 0 1-1.449-8.45l4.5-4.5a5.25 5.25 0 1 1 7.424 7.424l-1.757 1.757a.75.75 0 1 1-1.06-1.06l1.757-1.757a3.75 3.75 0 0 0 0-5.304m-7.389 4.267a.75.75 0 0 1 1-.353a5.25 5.25 0 0 1 1.449 8.45l-4.5 4.5a5.25 5.25 0 1 1-7.424-7.424l1.757-1.757a.75.75 0 1 1 1.06 1.06l-1.757 1.757a3.75 3.75 0 1 0 5.304 5.304l4.5-4.5a3.75 3.75 0 0 0-1.035-6.037a.75.75 0 0 1-.354-1"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-lock-open-solid">
        <path
          fill="currentColor"
          d="M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 0 1-1.5 0V6.75a3.75 3.75 0 1 0-7.5 0v3a3 3 0 0 1 3 3v6.75a3 3 0 0 1-3 3H3.75a3 3 0 0 1-3-3v-6.75a3 3 0 0 1 3-3h9v-3c0-2.9 2.35-5.25 5.25-5.25" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-lock-open">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M13.5 10.5V6.75a4.5 4.5 0 1 1 9 0v3.75M3.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H3.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-document-text-solid">
        <g fill="currentColor">
          <path
            fill-rule="evenodd"
            d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5zM7.5 15a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7.5 15m.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5z"
            clip-rule="evenodd" />
          <path
            d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279a9.77 9.77 0 0 0-6.963-6.963" />
        </g>
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-document-text">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-envelope">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-chat-bubble-bottom-center-text">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227q1.694.25 3.423.379c.35.026.67.21.865.501L12 21l2.755-4.132a1.14 1.14 0 0 1 .865-.502a48 48 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.4 48.4 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741z" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-language">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a49 49 0 0 1 6-.371m0 0q1.681 0 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138q1.344.092 2.666.257m-4.589 8.495a18 18 0 0 1-3.827-5.802" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-language-20-solid">
        <g fill="currentColor">
          <path
            d="M7.75 2.75a.75.75 0 0 0-1.5 0v1.258a33 33 0 0 0-3.599.278a.75.75 0 1 0 .198 1.487A31.6 31.6 0 0 1 8.7 5.545A19.4 19.4 0 0 1 7 9.56a19 19 0 0 1-1.002-2.05a.75.75 0 0 0-1.384.577a21 21 0 0 0 1.492 2.91a19.6 19.6 0 0 1-3.828 4.154a.75.75 0 1 0 .945 1.164A21 21 0 0 0 7 12.331q.143.198.29.391a.75.75 0 0 0 1.194-.91q-.306-.4-.59-.815a21 21 0 0 0 2.333-5.332q.465.047.924.108a.75.75 0 0 0 .198-1.487a33 33 0 0 0-3.599-.278z" />
          <path
            fill-rule="evenodd"
            d="M13 8a.75.75 0 0 1 .671.415l4.25 8.5a.75.75 0 1 1-1.342.67L15.787 16h-5.573l-.793 1.585a.75.75 0 1 1-1.342-.67l4.25-8.5A.75.75 0 0 1 13 8m2.037 6.5L13 10.427L10.964 14.5z"
            clip-rule="evenodd" />
        </g>
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-solid-ellipsis-horizontal">
        <path
          fill="currentColor"
          d="M3 10a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0Zm5.5 0a1.5 1.5 0 1 1 3 0a1.5 1.5 0 0 1-3 0Zm7-1.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0-3Z" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-solid-ellipsis-vertical">
        <path
          fill="currentColor"
          d="M10 3a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3Zm0 5.5a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0-3Zm1.5 7a1.5 1.5 0 1 0-3 0a1.5 1.5 0 0 0 3 0Z" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-solid-eye">
        <g fill="currentColor">
          <path d="M10 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4" />
          <path
            fill-rule="evenodd"
            d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10M14 10a4 4 0 1 1-8 0a4 4 0 0 1 8 0"
            clip-rule="evenodd" />
        </g>
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-outline-eye-off">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M13.875 18.825A10 10 0 0 1 12 19c-4.478 0-8.268-2.943-9.543-7A10 10 0 0 1 4.02 8.971m5.858.908a3 3 0 1 1 4.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88L6.59 6.59m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.95 9.95 0 0 1 12 5c4.478 0 8.268 2.943 9.543 7a10.03 10.03 0 0 1-4.132 5.411m0 0L21 21" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-arrow-right-start-on-rectangle-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M2 4.75A2.75 2.75 0 0 1 4.75 2h3a2.75 2.75 0 0 1 2.75 2.75v.5a.75.75 0 0 1-1.5 0v-.5c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-.5a.75.75 0 0 1 1.5 0v.5A2.75 2.75 0 0 1 7.75 14h-3A2.75 2.75 0 0 1 2 11.25zm9.47.47a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25a.75.75 0 1 1-1.06-1.06l.97-.97H5.25a.75.75 0 0 1 0-1.5h7.19l-.97-.97a.75.75 0 0 1 0-1.06"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-check-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M12.416 3.376a.75.75 0 0 1 .208 1.04l-5 7.5a.75.75 0 0 1-1.154.114l-3-3a.75.75 0 0 1 1.06-1.06l2.353 2.353l4.493-6.74a.75.75 0 0 1 1.04-.207"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-check-badge-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M15 8c0 .982-.472 1.854-1.202 2.402a3 3 0 0 1-.848 2.547a3 3 0 0 1-2.548.849A3 3 0 0 1 8 15a3 3 0 0 1-2.402-1.202a3 3 0 0 1-2.547-.848a3 3 0 0 1-.849-2.548A3 3 0 0 1 1 8c0-.982.472-1.854 1.202-2.402a3 3 0 0 1 .848-2.547a3 3 0 0 1 2.548-.849A3 3 0 0 1 8 1c.982 0 1.854.472 2.402 1.202a3 3 0 0 1 2.547.848c.695.695.978 1.645.849 2.548A3 3 0 0 1 15 8m-3.291-2.843a.75.75 0 0 1 .135 1.052l-4.25 5.5a.75.75 0 0 1-1.151.043l-2.25-2.5a.75.75 0 1 1 1.114-1.004l1.65 1.832l3.7-4.789a.75.75 0 0 1 1.052-.134"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-check-circle-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m3.844-8.791a.75.75 0 0 0-1.187-.918l-3.7 4.79l-1.65-1.833a.75.75 0 1 0-1.114 1.004l2.25 2.5a.75.75 0 0 0 1.15-.043z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-chevron-down-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-chevron-left-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M9.78 4.22a.75.75 0 0 1 0 1.06L7.06 8l2.72 2.72a.75.75 0 1 1-1.06 1.06L5.47 8.53a.75.75 0 0 1 0-1.06l3.25-3.25a.75.75 0 0 1 1.06 0"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-chevron-right-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M6.22 4.22a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06l-3.25 3.25a.75.75 0 0 1-1.06-1.06L8.94 8L6.22 5.28a.75.75 0 0 1 0-1.06"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-chevron-up-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M11.78 9.78a.75.75 0 0 1-1.06 0L8 7.06L5.28 9.78a.75.75 0 0 1-1.06-1.06l3.25-3.25a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-clipboard-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M10.986 3H12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h1.014A2.25 2.25 0 0 1 7.25 1h1.5a2.25 2.25 0 0 1 2.236 2M9.5 4v-.75a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75V4z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-exclamation-circle-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14M8 4a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3A.75.75 0 0 1 8 4m0 8a1 1 0 1 0 0-2a1 1 0 0 0 0 2"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-exclamation-triangle-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M6.701 2.25c.577-1 2.02-1 2.598 0l5.196 9a1.5 1.5 0 0 1-1.299 2.25H2.804a1.5 1.5 0 0 1-1.3-2.25zM8 4a.75.75 0 0 1 .75.75v3a.75.75 0 1 1-1.5 0v-3A.75.75 0 0 1 8 4m0 8a1 1 0 1 0 0-2a1 1 0 0 0 0 2"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-face-frown-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M6 8c.552 0 1-.672 1-1.5S6.552 5 6 5s-1 .672-1 1.5S5.448 8 6 8m5-1.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5m-6.005 5.805a.75.75 0 0 0 1.06 0a2.75 2.75 0 0 1 3.89 0a.75.75 0 0 0 1.06-1.06a4.25 4.25 0 0 0-6.01 0a.75.75 0 0 0 0 1.06"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-face-smile-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M6 8c.552 0 1-.672 1-1.5S6.552 5 6 5s-1 .672-1 1.5S5.448 8 6 8m5-1.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5m.005 4.245a.75.75 0 0 0-1.06 0a2.75 2.75 0 0 1-3.89 0a.75.75 0 0 0-1.06 1.06a4.25 4.25 0 0 0 6.01 0a.75.75 0 0 0 0-1.06"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-fire-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8.074.945A5 5 0 0 0 6 5v.032c.004.6.114 1.176.311 1.709c.16.428-.204.91-.61.7a5 5 0 0 1-1.868-1.677c-.202-.304-.648-.363-.848-.058a6 6 0 1 0 8.017-1.901l-.004-.007a4.98 4.98 0 0 1-2.18-2.574c-.116-.31-.477-.472-.744-.28m.78 6.178a3.001 3.001 0 1 1-3.473 4.341c-.205-.365.215-.694.62-.59a4 4 0 0 0 1.873.03c.288-.065.413-.386.321-.666A4 4 0 0 1 8 8.999c0-.585.126-1.14.351-1.641a.42.42 0 0 1 .503-.235"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-globe-alt-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M3.757 4.5q.27.326.586.608c.153-.61.354-1.175.596-1.678A5.5 5.5 0 0 0 3.757 4.5M8 1a6.994 6.994 0 0 0-7 7q0 .226.014.447A7 7 0 1 0 8 1m0 1.5c-.476 0-1.091.386-1.633 1.427c-.293.564-.531 1.267-.683 2.063A5.5 5.5 0 0 0 8 6.5a5.5 5.5 0 0 0 2.316-.51c-.152-.796-.39-1.499-.683-2.063C9.09 2.886 8.476 2.5 8 2.5m3.657 2.608a9 9 0 0 0-.596-1.678c.444.298.842.659 1.182 1.07q-.27.326-.586.608m-1.166 2.436A7 7 0 0 1 8 8a7 7 0 0 1-2.49-.456Q5.5 7.769 5.5 8c0 .765.076 1.489.21 2.144c.722.231 1.492.356 2.29.356s1.568-.125 2.29-.356a10.7 10.7 0 0 0 .2-2.6m1.433 1.85a12.7 12.7 0 0 0 .018-2.609q.61-.416 1.117-.947a5.5 5.5 0 0 1 .44 2.262a7.5 7.5 0 0 1-1.575 1.293m-2.172 2.435a9 9 0 0 1-3.504 0q.058.127.12.244C6.907 13.114 7.523 13.5 8 13.5s1.091-.386 1.633-1.427q.06-.117.12-.244m1.31.74a8.5 8.5 0 0 0 .492-1.298q.686-.296 1.307-.696a5.5 5.5 0 0 1-1.8 1.995m-6.123 0a8.5 8.5 0 0 1-.493-1.298a9 9 0 0 1-1.307-.696a5.5 5.5 0 0 0 1.8 1.995M2.5 8.1c.463.5.993.935 1.575 1.293a12.7 12.7 0 0 1-.018-2.608a7 7 0 0 1-1.117-.947A5.5 5.5 0 0 0 2.5 8.1"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-globe-americas-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M4.5 3.757a5.5 5.5 0 1 0 6.857-.114l-.65.65a.7.7 0 0 0-.207.5c0 .39-.317.707-.707.707H8.427a.496.496 0 0 0-.413.771l.25.376a.48.48 0 0 0 .616.163a.96.96 0 0 1 1.11.18l.573.573a1 1 0 0 1 .242 1.023l-1.012 3.035a1 1 0 0 1-1.191.654l-.345-.086a1 1 0 0 1-.757-.97v-.305a1 1 0 0 0-.293-.707L6.1 9.1a.85.85 0 0 1 0-1.2c.22-.22.22-.58 0-.8l-.721-.721A3 3 0 0 1 4.5 4.257z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-globe-asia-australia-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7 5.5a5.5 5.5 0 0 1-4.007-1.732l.28-.702a.402.402 0 0 1 .658-.135a.804.804 0 0 0 1.138 0l.012-.012a.82.82 0 0 0 .154-.949l-.055-.11a.5.5 0 0 1 .134-.611L8.14 7.788a.57.57 0 0 0 .154-.7a.57.57 0 0 1 .33-.796l.028-.01a1.79 1.79 0 0 0 1.13-1.13l.072-.214a.75.75 0 0 0-.18-.764L8.293 2.793A1 1 0 0 1 8.09 2.5a5.5 5.5 0 0 1 4.81 8h-.486a1 1 0 0 1-.707-.293l-.353-.353a1.207 1.207 0 0 0-1.708 0l-.531.531a1 1 0 0 1-.26.188l-.343.17a.93.93 0 0 0-.512.83v.177c0 .414.336.75.75.75a.75.75 0 0 1 .751.793c-.477.135-.98.207-1.501.207"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-globe-europe-africa-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M5.657 3.023a5.5 5.5 0 1 0 7.584 3.304l-.947-.63a.43.43 0 0 0-.544.053a.43.43 0 0 1-.544.054l-.467-.312a.475.475 0 0 0-.689.608l.226.453a2.12 2.12 0 0 1 0 1.894L10.1 8.8a.95.95 0 0 0-.1.424v.11a2 2 0 0 1-.4 1.2L8.8 11.6A1 1 0 0 1 7 11v-.382a1 1 0 0 0-.553-.894l-.422-.212A1.854 1.854 0 0 1 6.855 6h.707a.438.438 0 1 0-.107-.864l-.835.209a1.129 1.129 0 0 1-1.305-1.553z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-hand-raised-16-solid">
        <path
          fill="currentColor"
          d="M8.5 1a.75.75 0 0 0-.75.75V6.5a.5.5 0 0 1-1 0V2.75a.75.75 0 0 0-1.5 0V7.5a.5.5 0 0 1-1 0V4.75a.75.75 0 0 0-1.5 0v4.5a5.75 5.75 0 0 0 11.5 0v-2.5a.75.75 0 0 0-1.5 0V9.5a.5.5 0 0 1-1 0V2.75a.75.75 0 0 0-1.5 0V6.5a.5.5 0 0 1-1 0V1.75A.75.75 0 0 0 8.5 1" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-hand-thumb-down-16-solid">
        <path
          fill="currentColor"
          d="M10.325 3H12v5c-.663 0-1.219.466-1.557 1.037a4 4 0 0 1-1.357 1.377c-.478.292-.907.706-.989 1.26v.005a9 9 0 0 0 0 2.642c.028.194-.048.394-.224.479A2 2 0 0 1 5 13q.002-1.22.234-2.371a.52.52 0 0 0-.5-.629H3c-1.104 0-2.01-.898-1.9-1.997q.03-.308.07-.613a19.8 19.8 0 0 1 1.011-4.174C2.45 2.468 3.178 2 3.973 2h2.703a2 2 0 0 1 .632.103l2.384.794a2 2 0 0 0 .633.103M14 2a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V3a1 1 0 0 0-1-1" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-hand-thumb-up-16-solid">
        <path
          fill="currentColor"
          d="M2.09 15a1 1 0 0 0 1-1V8a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1m3.675-2H4.09V8c.663 0 1.218-.466 1.556-1.037a4 4 0 0 1 1.358-1.377c.478-.292.907-.706.989-1.26V4.32a9 9 0 0 0 0-2.642c-.028-.194.048-.394.224-.479A2 2 0 0 1 11.09 3q-.001 1.22-.235 2.371a.52.52 0 0 0 .502.629h1.733c1.104 0 2.01.898 1.901 1.997q-.03.308-.07.613a20 20 0 0 1-1.011 4.174c-.27.748-.998 1.216-1.793 1.216H9.414q-.324 0-.632-.103l-2.384-.794A2 2 0 0 0 5.765 13" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-heart-16-solid">
        <path
          fill="currentColor"
          d="M2 6.342a3.375 3.375 0 0 1 6-2.088a3.375 3.375 0 0 1 5.997 2.26c-.063 2.134-1.618 3.76-2.955 4.784a14.4 14.4 0 0 1-2.676 1.61q-.031.015-.05.022l-.014.006l-.004.002h-.002a.75.75 0 0 1-.592.001h-.002l-.004-.003l-.015-.006a6 6 0 0 1-.232-.107a14.4 14.4 0 0 1-2.535-1.557C3.564 10.22 1.999 8.558 1.999 6.38z" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-lock-closed-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8 1a3.5 3.5 0 0 0-3.5 3.5V7A1.5 1.5 0 0 0 3 8.5v5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 11.5 7V4.5A3.5 3.5 0 0 0 8 1m2 6V4.5a2 2 0 1 0-4 0V7z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-question-mark-circle-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-6 3.5a1 1 0 1 1-2 0a1 1 0 0 1 2 0M7.293 5.293a1 1 0 1 1 .99 1.667c-.459.134-1.033.566-1.033 1.29v.25a.75.75 0 1 0 1.5 0v-.115a2.5 2.5 0 1 0-2.518-4.153a.75.75 0 1 0 1.061 1.06"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-shield-check-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8.5 1.709a.75.75 0 0 0-1 0a8.96 8.96 0 0 1-4.84 2.217a.75.75 0 0 0-.654.72Q2 4.821 2 5c0 4.052 2.295 7.567 5.653 9.317a.75.75 0 0 0 .694 0a10.5 10.5 0 0 0 5.647-9.672a.75.75 0 0 0-.654-.719A8.96 8.96 0 0 1 8.5 1.71m2.34 5.504a.75.75 0 0 0-1.18-.926L7.394 9.17l-1.156-.99a.75.75 0 1 0-.976 1.138l1.75 1.5a.75.75 0 0 0 1.078-.106z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-shield-exclamation-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M7.5 1.709a.75.75 0 0 1 1 0a8.96 8.96 0 0 0 4.84 2.217a.75.75 0 0 1 .654.72Q14 4.82 14 5c0 4.052-2.295 7.567-5.653 9.317a.75.75 0 0 1-.694 0a10.5 10.5 0 0 1-5.647-9.672a.75.75 0 0 1 .654-.719A8.96 8.96 0 0 0 7.5 1.71M8 5a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2A.75.75 0 0 1 8 5m0 7a1 1 0 1 0 0-2a1 1 0 0 0 0 2"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-trash-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M5 3.25V4H2.75a.75.75 0 0 0 0 1.5h.3l.815 8.15A1.5 1.5 0 0 0 5.357 15h5.286a1.5 1.5 0 0 0 1.492-1.35l.815-8.15h.3a.75.75 0 0 0 0-1.5H11v-.75A2.25 2.25 0 0 0 8.75 1h-1.5A2.25 2.25 0 0 0 5 3.25m2.25-.75a.75.75 0 0 0-.75.75V4h3v-.75a.75.75 0 0 0-.75-.75zM6.05 6a.75.75 0 0 1 .787.713l.275 5.5a.75.75 0 0 1-1.498.075l-.275-5.5A.75.75 0 0 1 6.05 6m3.9 0a.75.75 0 0 1 .712.787l-.275 5.5a.75.75 0 0 1-1.498-.075l.275-5.5a.75.75 0 0 1 .786-.711"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-x-mark-16-solid">
        <path
          fill="currentColor"
          d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94z" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-arrow-left-start-on-rectangle-20-solid">
        <g
          fill="currentColor"
          fill-rule="evenodd"
          clip-rule="evenodd">
          <path
            d="M17 4.25A2.25 2.25 0 0 0 14.75 2h-5.5A2.25 2.25 0 0 0 7 4.25v2a.75.75 0 0 0 1.5 0v-2a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 .75.75v11.5a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75v-2a.75.75 0 0 0-1.5 0v2A2.25 2.25 0 0 0 9.25 18h5.5A2.25 2.25 0 0 0 17 15.75z" />
          <path
            d="M14 10a.75.75 0 0 0-.75-.75H3.704l1.048-.943a.75.75 0 1 0-1.004-1.114l-2.5 2.25a.75.75 0 0 0 0 1.114l2.5 2.25a.75.75 0 1 0 1.004-1.114l-1.048-.943h9.546A.75.75 0 0 0 14 10" />
        </g>
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-arrow-right-end-on-rectangle-20-solid">
        <g
          fill="currentColor"
          fill-rule="evenodd"
          clip-rule="evenodd">
          <path
            d="M17 4.25A2.25 2.25 0 0 0 14.75 2h-5.5A2.25 2.25 0 0 0 7 4.25v2a.75.75 0 0 0 1.5 0v-2a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 .75.75v11.5a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75v-2a.75.75 0 0 0-1.5 0v2A2.25 2.25 0 0 0 9.25 18h5.5A2.25 2.25 0 0 0 17 15.75z" />
          <path
            d="M1 10a.75.75 0 0 1 .75-.75h9.546l-1.048-.943a.75.75 0 1 1 1.004-1.114l2.5 2.25a.75.75 0 0 1 0 1.114l-2.5 2.25a.75.75 0 1 1-1.004-1.114l1.048-.943H1.75A.75.75 0 0 1 1 10" />
        </g>
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-check-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M16.705 4.153a.75.75 0 0 1 .142 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893l7.48-9.817a.75.75 0 0 1 1.05-.143"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-check-badge-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M16.403 12.652a3 3 0 0 0 0-5.304a3 3 0 0 0-3.75-3.751a3 3 0 0 0-5.305 0a3 3 0 0 0-3.751 3.75a3 3 0 0 0 0 5.305a3 3 0 0 0 3.75 3.751a3 3 0 0 0 5.305 0a3 3 0 0 0 3.751-3.75m-2.546-4.46a.75.75 0 0 0-1.214-.883L9.16 12.1l-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-check-circle-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79l-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-chevron-down-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-chevron-left-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-chevron-right-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10L8.22 6.28a.75.75 0 0 1 0-1.06"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-chevron-up-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M9.47 6.47a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 1 1-1.06 1.06L10 8.06l-3.72 3.72a.75.75 0 0 1-1.06-1.06z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-clipboard-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M13.887 3.182q.594.056 1.183.128A2.213 2.213 0 0 1 17 5.517V16.75A2.25 2.25 0 0 1 14.75 19h-9.5A2.25 2.25 0 0 1 3 16.75V5.517c0-1.103.806-2.068 1.93-2.207q.59-.071 1.183-.128A3 3 0 0 1 9 1h2c1.373 0 2.531.923 2.887 2.182M7.5 4A1.5 1.5 0 0 1 9 2.5h2A1.5 1.5 0 0 1 12.5 4v.5h-5z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-cog-20-solid">
        <g fill="currentColor">
          <path
            d="M13.024 9.25c.47 0 .827-.433.637-.863a4 4 0 0 0-4.094-2.364c-.468.05-.665.576-.43.984l1.08 1.868a.75.75 0 0 0 .649.375zM7.84 7.758c-.236-.408-.79-.5-1.068-.12A4 4 0 0 0 6 10c0 .884.287 1.7.772 2.363c.278.38.832.287 1.068-.12l1.078-1.868a.75.75 0 0 0 0-.75zm1.298 5.235c-.235.408-.039.934.43.984Q9.78 14 10 14a4 4 0 0 0 3.661-2.387c.19-.43-.167-.863-.637-.863h-2.158a.75.75 0 0 0-.65.375z" />
          <path
            fill-rule="evenodd"
            d="m14.13 4.347l.644-1.117a.75.75 0 0 0-1.299-.75l-.644 1.116a7 7 0 0 0-2.081-.556V1.75a.75.75 0 0 0-1.5 0v1.29a7 7 0 0 0-2.081.556L6.525 2.48a.75.75 0 1 0-1.3.75l.645 1.117A7 7 0 0 0 4.347 5.87L3.23 5.225a.75.75 0 1 0-.75 1.3l1.116.644A7 7 0 0 0 3.04 9.25H1.75a.75.75 0 0 0 0 1.5h1.29a7 7 0 0 0 .556 2.081l-1.116.645a.75.75 0 1 0 .75 1.298l1.117-.644a7 7 0 0 0 1.523 1.523l-.645 1.117a.75.75 0 1 0 1.3.75l.644-1.116a7 7 0 0 0 2.081.556v1.29a.75.75 0 0 0 1.5 0v-1.29a7 7 0 0 0 2.081-.556l.645 1.116a.75.75 0 0 0 1.299-.75l-.645-1.117a7 7 0 0 0 1.523-1.523l1.117.644a.75.75 0 0 0 .75-1.298l-1.116-.645a7 7 0 0 0 .556-2.081h1.29a.75.75 0 0 0 0-1.5h-1.29a7 7 0 0 0-.556-2.081l1.116-.644a.75.75 0 0 0-.75-1.3l-1.117.645a7 7 0 0 0-1.524-1.523M10 4.5a5.5 5.5 0 0 0-2.781.754A5.5 5.5 0 0 0 5.22 7.277A5.5 5.5 0 0 0 4.5 10a5.5 5.5 0 0 0 .752 2.777a5.5 5.5 0 0 0 2.028 2.004c.802.458 1.73.719 2.72.719a5.5 5.5 0 0 0 2.78-.753a5.5 5.5 0 0 0 2.001-2.027c.458-.802.719-1.73.719-2.72a5.5 5.5 0 0 0-.753-2.78a5.5 5.5 0 0 0-2.028-2.002A5.5 5.5 0 0 0 10 4.5"
            clip-rule="evenodd" />
        </g>
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-cog-6-tooth-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M7.84 1.804A1 1 0 0 1 8.82 1h2.36a1 1 0 0 1 .98.804l.331 1.652a7 7 0 0 1 1.929 1.115l1.598-.54a1 1 0 0 1 1.186.447l1.18 2.044a1 1 0 0 1-.205 1.251l-1.267 1.113a7 7 0 0 1 0 2.228l1.267 1.113a1 1 0 0 1 .206 1.25l-1.18 2.045a1 1 0 0 1-1.187.447l-1.598-.54a7 7 0 0 1-1.929 1.115l-.33 1.652a1 1 0 0 1-.98.804H8.82a1 1 0 0 1-.98-.804l-.331-1.652a7 7 0 0 1-1.929-1.115l-1.598.54a1 1 0 0 1-1.186-.447l-1.18-2.044a1 1 0 0 1 .205-1.251l1.267-1.114a7 7 0 0 1 0-2.227L1.821 7.773a1 1 0 0 1-.206-1.25l1.18-2.045a1 1 0 0 1 1.187-.447l1.598.54a7 7 0 0 1 1.93-1.115zM10 13a3 3 0 1 0 0-6a3 3 0 0 0 0 6"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-exclamation-circle-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M18 10a8 8 0 1 1-16 0a8 8 0 0 1 16 0m-8-5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 10 5m0 10a1 1 0 1 0 0-2a1 1 0 0 0 0 2"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-exclamation-triangle-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625zM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5m0 9a1 1 0 1 0 0-2a1 1 0 0 0 0 2"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-face-frown-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m-3.536-3.475a.75.75 0 0 0 1.061 0a3.5 3.5 0 0 1 4.95 0a.75.75 0 1 0 1.06-1.06a5 5 0 0 0-7.07 0a.75.75 0 0 0 0 1.06M9 8.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S7.448 7 8 7s1 .672 1 1.5m3 1.5c.552 0 1-.672 1-1.5S12.552 7 12 7s-1 .672-1 1.5s.448 1.5 1 1.5"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-face-smile-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M10 18a8 8 0 1 0 0-16a8 8 0 0 0 0 16m3.536-4.464a.75.75 0 1 0-1.061-1.061a3.5 3.5 0 0 1-4.95 0a.75.75 0 0 0-1.06 1.06a5 5 0 0 0 7.07 0M9 8.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S7.448 7 8 7s1 .672 1 1.5m3 1.5c.552 0 1-.672 1-1.5S12.552 7 12 7s-1 .672-1 1.5s.448 1.5 1 1.5"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-fire-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M13.5 4.938a7 7 0 1 1-9.006 1.737c.202-.257.59-.218.793.039q.418.53.943.954c.332.269.786-.049.773-.476L7 7c0-.919.206-1.789.575-2.567a6.03 6.03 0 0 1 2.486-2.665c.247-.14.55-.016.677.238A6.97 6.97 0 0 0 13.5 4.938M14 12a4 4 0 0 1-4 4c-1.913 0-3.52-1.398-3.91-3.182c-.093-.429.44-.643.814-.413a4 4 0 0 0 1.601.564c.303.038.531-.24.51-.544a5.98 5.98 0 0 1 1.315-4.192a.45.45 0 0 1 .431-.16A4 4 0 0 1 14 12"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-globe-alt-20-solid">
        <path
          fill="currentColor"
          d="M16.555 5.412a8.03 8.03 0 0 0-3.503-2.81a14.9 14.9 0 0 1 1.663 4.472a8.6 8.6 0 0 0 1.84-1.662m-3.229 2.413a13.4 13.4 0 0 0-2.413-5.773a8 8 0 0 0-1.826 0a13.4 13.4 0 0 0-2.413 5.773A8.5 8.5 0 0 0 10 8.5c1.18 0 2.304-.24 3.326-.675M6.514 9.376A10 10 0 0 0 10 10c1.226 0 2.4-.22 3.486-.624q.014.31.014.624a13.5 13.5 0 0 1-.366 3.134A13.5 13.5 0 0 1 10 13.5c-1.079 0-2.128-.127-3.134-.366a13.5 13.5 0 0 1-.352-3.758M5.285 7.074a14.9 14.9 0 0 1 1.663-4.471a8.03 8.03 0 0 0-3.503 2.81a8.6 8.6 0 0 0 1.84 1.66m12.049-.275a8 8 0 0 1 .614 4.115a13.5 13.5 0 0 1-3.178 1.72a15 15 0 0 0 .174-3.939a10 10 0 0 0 2.39-1.896m-14.668 0a10 10 0 0 0 2.39 1.896a15.2 15.2 0 0 0 .174 3.94a13.5 13.5 0 0 1-3.178-1.72a8 8 0 0 1 .615-4.115M10 15q1.349-.002 2.633-.23a13.5 13.5 0 0 1-1.72 3.178a8 8 0 0 1-1.826 0a13.5 13.5 0 0 1-1.72-3.178Q8.65 14.998 10 15m4.357-.643a15 15 0 0 1-1.305 3.04a8.03 8.03 0 0 0 4.345-4.345c-.953.542-1.971.981-3.04 1.305m-7.409 3.04a8.03 8.03 0 0 1-4.345-4.345c.953.542 1.971.981 3.04 1.305a15 15 0 0 0 1.305 3.04" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-globe-americas-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M18 10a8 8 0 1 1-16 0a8 8 0 0 1 16 0m-1.5 0a6.5 6.5 0 1 1-11-4.69v.447a3.5 3.5 0 0 0 1.025 2.475L8.293 10L8 10.293a1 1 0 0 0 0 1.414l1.06 1.06a1.5 1.5 0 0 1 .44 1.061v.363a1 1 0 0 0 .553.894l.276.139a1 1 0 0 0 1.342-.448l1.454-2.908a1.5 1.5 0 0 0-.281-1.731l-.772-.772a1 1 0 0 0-1.023-.242l-.384.128a.5.5 0 0 1-.606-.25l-.296-.592a.481.481 0 0 1 .646-.646l.262.131a1 1 0 0 0 .447.106h.188a1 1 0 0 0 .949-1.316l-.068-.204a.5.5 0 0 1 .149-.538l1.44-1.234A6.5 6.5 0 0 1 16.5 10"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-globe-asia-australia-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M18 10a8 8 0 1 1-16 0a8 8 0 0 1 16 0m-6.5 6.326a6.5 6.5 0 0 1-1.5.174a6.49 6.49 0 0 1-5.011-2.36l.49-.98a.423.423 0 0 1 .614-.164l.294.196a.992.992 0 0 0 1.491-1.139l-.197-.593a.25.25 0 0 1 .126-.304l1.973-.987a.938.938 0 0 0 .361-1.359a.375.375 0 0 1 .239-.576l.125-.025A2.42 2.42 0 0 0 12.327 6.6l.05-.149a1 1 0 0 0-.242-1.023l-1.489-1.489a.5.5 0 0 1-.146-.353v-.067a6.5 6.5 0 0 1 5.392 9.23a1.4 1.4 0 0 0-.68-.244l-.566-.566a1.5 1.5 0 0 0-1.06-.439h-.172a1.5 1.5 0 0 0-1.06.44l-.593.592a.5.5 0 0 1-.13.093l-1.578.79a1 1 0 0 0-.553.894v.191a1 1 0 0 0 1 1h.5a.5.5 0 0 1 .5.5z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-globe-europe-africa-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M18 10a8 8 0 1 1-16 0a8 8 0 0 1 16 0m-1.503.204A6.5 6.5 0 1 1 7.95 3.83L6.927 5.62a1.453 1.453 0 0 0 1.91 2.02l.175-.087a.5.5 0 0 1 .224-.053h.146a.5.5 0 0 1 .447.724l-.028.055a.4.4 0 0 1-.357.221h-.502a2.26 2.26 0 0 0-1.88 1.006l-.044.066a2.1 2.1 0 0 0 1.085 3.156a.58.58 0 0 1 .397.547v1.05a1.175 1.175 0 0 0 2.093.734l1.611-2.014c.192-.24.296-.536.296-.842c0-.316.128-.624.353-.85a1.36 1.36 0 0 0 .173-1.716l-.464-.696a.369.369 0 0 1 .527-.499l.343.257a1.04 1.04 0 0 0 1.091.098a.59.59 0 0 1 .677.11z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-hand-raised-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M11 2a1 1 0 1 0-2 0v6.5a.5.5 0 0 1-1 0V3a1 1 0 1 0-2 0v5.5a.5.5 0 0 1-1 0V5a1 1 0 1 0-2 0v7a7 7 0 1 0 14 0V8a1 1 0 1 0-2 0v3.5a.5.5 0 0 1-1 0V3a1 1 0 1 0-2 0v5.5a.5.5 0 0 1-1 0z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-hand-thumb-down-20-solid">
        <path
          fill="currentColor"
          d="M18.905 12.75a1.25 1.25 0 1 1-2.5 0v-7.5a1.25 1.25 0 0 1 2.5 0zm-10 4.25v1.3c0 .268-.14.526-.395.607q-.287.091-.605.093a2 2 0 0 1-2-2c0-.995.182-1.948.514-2.826c.204-.54-.166-1.174-.744-1.174h-2.52c-1.243 0-2.261-1.01-2.146-2.247c.193-2.08.651-4.082 1.341-5.974C2.752 3.678 3.833 3 5.005 3h3.192a3 3 0 0 1 1.341.317l2.734 1.366A3 3 0 0 0 13.613 5h1.292v7h-.963c-.685 0-1.258.482-1.612 1.068a4 4 0 0 1-2.166 1.73c-.432.143-.853.386-1.011.814c-.16.432-.248.9-.248 1.388" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-hand-thumb-up-20-solid">
        <path
          fill="currentColor"
          d="M1 8.25a1.25 1.25 0 1 1 2.5 0v7.5a1.25 1.25 0 1 1-2.5 0zM11 3V1.7c0-.268.14-.526.395-.607A2 2 0 0 1 14 3c0 .995-.182 1.948-.514 2.826c-.204.54.166 1.174.744 1.174h2.52c1.243 0 2.261 1.01 2.146 2.247a24 24 0 0 1-1.341 5.974C17.153 16.323 16.072 17 14.9 17h-3.192a3 3 0 0 1-1.341-.317l-2.734-1.366A3 3 0 0 0 6.292 15H5V8h.963c.685 0 1.258-.483 1.612-1.068a4 4 0 0 1 2.166-1.73c.432-.143.853-.386 1.011-.814c.16-.432.248-.9.248-1.388" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-heart-20-solid">
        <path
          fill="currentColor"
          d="m9.653 16.915l-.005-.003l-.019-.01l-.067-.035l-.243-.135a22 22 0 0 1-3.434-2.412C4.045 12.733 2 10.352 2 7.5a4.5 4.5 0 0 1 8-2.828A4.5 4.5 0 0 1 18 7.5c0 2.852-2.044 5.233-3.885 6.82a22 22 0 0 1-3.744 2.582l-.019.01l-.005.003h-.002a.74.74 0 0 1-.69.001z" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-information-circle-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M18 10a8 8 0 1 1-16 0a8 8 0 0 1 16 0m-7-4a1 1 0 1 1-2 0a1 1 0 0 1 2 0M9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-lock-closed-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1m3 8V5.5a3 3 0 1 0-6 0V9z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-paper-clip-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M15.621 4.379a3 3 0 0 0-4.242 0l-7 7a3 3 0 0 0 4.241 4.243h.001l.497-.5a.75.75 0 0 1 1.064 1.057l-.498.501l-.002.002a4.5 4.5 0 0 1-6.364-6.364l7-7a4.5 4.5 0 0 1 6.368 6.36l-3.455 3.553A2.625 2.625 0 1 1 9.52 9.52l3.45-3.451a.75.75 0 1 1 1.061 1.06l-3.45 3.451a1.125 1.125 0 0 0 1.587 1.595l3.454-3.553a3 3 0 0 0 0-4.242"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-plus-20-solid">
        <path
          fill="currentColor"
          d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5z" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-plus-16-solid">
        <path
          fill="currentColor"
          d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5z" />
      </symbol>
      <symbol
        viewBox="0 0 16 16"
        id="heroicons-plus-circle-16-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m.75-10.25v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5a.75.75 0 0 1 1.5 0"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-plus-circle">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0a9 9 0 0 1 18 0" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-question-mark-circle-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M18 10a8 8 0 1 1-16 0a8 8 0 0 1 16 0M8.94 6.94a.75.75 0 1 1-1.061-1.061a3 3 0 1 1 2.871 5.026v.345a.75.75 0 0 1-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 1 0 8.94 6.94M10 15a1 1 0 1 0 0-2a1 1 0 0 0 0 2"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-shield-check-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M9.661 2.237a.53.53 0 0 1 .678 0a11.95 11.95 0 0 0 7.078 2.749a.5.5 0 0 1 .479.425q.104.78.104 1.59c0 5.162-3.26 9.563-7.834 11.256a.48.48 0 0 1-.332 0C5.26 16.564 2 12.163 2 7q0-.808.104-1.589a.5.5 0 0 1 .48-.425a11.95 11.95 0 0 0 7.077-2.75m4.196 5.954a.75.75 0 0 0-1.214-.882l-3.483 4.79l-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-shield-exclamation-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M10.339 2.237a.53.53 0 0 0-.678 0a11.95 11.95 0 0 1-7.078 2.75a.5.5 0 0 0-.479.425A12 12 0 0 0 2 7c0 5.163 3.26 9.564 7.834 11.257a.48.48 0 0 0 .332 0C14.74 16.564 18 12.163 18 7q0-.808-.104-1.589a.5.5 0 0 0-.48-.425a11.95 11.95 0 0 1-7.077-2.75M10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 6m0 9a1 1 0 1 0 0-2a1 1 0 0 0 0 2"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-trash-20-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443q-1.193.115-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022l.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52l.149.023a.75.75 0 0 0 .23-1.482A41 41 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1zM10 4q1.26 0 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325Q8.74 4 10 4M8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 20 20"
        id="heroicons-x-mark-20-solid">
        <path
          fill="currentColor"
          d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94z" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-left-end-on-rectangle-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5zm5.03 4.72a.75.75 0 0 1 0 1.06l-1.72 1.72h10.94a.75.75 0 0 1 0 1.5H10.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-left-on-rectangle-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5zm5.03 4.72a.75.75 0 0 1 0 1.06l-1.72 1.72h10.94a.75.75 0 0 1 0 1.5H10.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-left-start-on-rectangle-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M16.5 3.75a1.5 1.5 0 0 1 1.5 1.5v13.5a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V15a.75.75 0 0 0-1.5 0v3.75a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5.25a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3V9A.75.75 0 1 0 9 9V5.25a1.5 1.5 0 0 1 1.5-1.5zM5.78 8.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06-1.06l-1.72-1.72H15a.75.75 0 0 0 0-1.5H4.06l1.72-1.72a.75.75 0 0 0 0-1.06"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-right-end-on-rectangle-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M16.5 3.75a1.5 1.5 0 0 1 1.5 1.5v13.5a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V15a.75.75 0 0 0-1.5 0v3.75a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5.25a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3V9A.75.75 0 1 0 9 9V5.25a1.5 1.5 0 0 1 1.5-1.5zm-5.03 4.72a.75.75 0 0 0 0 1.06l1.72 1.72H2.25a.75.75 0 0 0 0 1.5h10.94l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 0"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-right-on-rectangle-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5zm10.72 4.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H9a.75.75 0 0 1 0-1.5h10.94l-1.72-1.72a.75.75 0 0 1 0-1.06"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-right-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M12.97 3.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06l6.22-6.22H3a.75.75 0 0 1 0-1.5h16.19l-6.22-6.22a.75.75 0 0 1 0-1.06"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-right-start-on-rectangle-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5zm10.72 4.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H9a.75.75 0 0 1 0-1.5h10.94l-1.72-1.72a.75.75 0 0 1 0-1.06"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-left-on-rectangle">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-left-start-on-rectangle">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-right-end-on-rectangle">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-right-on-rectangle">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-arrow-right-start-on-rectangle">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-check-badge-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M8.603 3.799A4.5 4.5 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.5 4.5 0 0 1 3.498 1.307a4.5 4.5 0 0 1 1.307 3.497A4.5 4.5 0 0 1 21.75 12a4.5 4.5 0 0 1-1.549 3.397a4.5 4.5 0 0 1-1.307 3.497a4.5 4.5 0 0 1-3.497 1.307A4.5 4.5 0 0 1 12 21.75a4.5 4.5 0 0 1-3.397-1.549a4.5 4.5 0 0 1-3.498-1.306a4.5 4.5 0 0 1-1.307-3.498A4.5 4.5 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.5 4.5 0 0 1 1.307-3.497a4.5 4.5 0 0 1 3.497-1.307m7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-check-badge">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M9 12.75L11.25 15L15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.75 3.75 0 0 1-1.043 3.296a3.75 3.75 0 0 1-3.296 1.043A3.75 3.75 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.75 3.75 0 0 1-3.296-1.043a3.75 3.75 0 0 1-1.043-3.296A3.75 3.75 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.75 3.75 0 0 1 1.043-3.296a3.75 3.75 0 0 1 3.296-1.043A3.75 3.75 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.75 3.75 0 0 1 3.296 1.043a3.75 3.75 0 0 1 1.043 3.296A3.75 3.75 0 0 1 21 12" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-check-circle-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12m13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-check-circle">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M9 12.75L11.25 15L15 9.75M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-check-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353l8.493-12.74a.75.75 0 0 1 1.04-.207"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-check">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m4.5 12.75l6 6l9-13.5" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-chevron-down-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-chevron-down">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m19.5 8.25l-7.5 7.5l-7.5-7.5" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-chevron-left-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-chevron-left">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M15.75 19.5L8.25 12l7.5-7.5" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-chevron-right-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12L7.72 5.03a.75.75 0 0 1 1.06-1.06z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-chevron-right">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m8.25 4.5l7.5 7.5l-7.5 7.5" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-chevron-up-down">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M8.25 15L12 18.75L15.75 15m-7.5-6L12 5.25L15.75 9" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-chevron-up-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M11.47 7.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-chevron-up">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m4.5 15.75l7.5-7.5l7.5 7.5" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-clipboard-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M10.5 3A1.5 1.5 0 0 0 9 4.5h6q-.001-.215-.056-.409A1.5 1.5 0 0 0 13.5 3zm-2.693.178A3 3 0 0 1 10.5 1.5h3a3 3 0 0 1 2.694 1.678q.745.063 1.486.15c1.497.173 2.57 1.46 2.57 2.929V19.5a3 3 0 0 1-3 3H6.75a3 3 0 0 1-3-3V6.257c0-1.47 1.073-2.756 2.57-2.93q.74-.086 1.487-.15"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-clipboard">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0q.083.292.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0q.002-.32.084-.612m7.332 0q.969.073 1.927.184c1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48 48 0 0 1 1.927-.184" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-cog-6-tooth-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.5 7.5 0 0 0-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 0 0-2.282.819l-.922 1.597a1.875 1.875 0 0 0 .432 2.385l.84.692c.095.078.17.229.154.43a7.6 7.6 0 0 0 0 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 0 0-.432 2.385l.922 1.597a1.875 1.875 0 0 0 2.282.818l1.019-.382c.115-.043.283-.031.45.082q.468.322.985.57c.182.088.277.228.297.35l.178 1.071a1.876 1.876 0 0 0 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349q.516-.248.985-.57c.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 0 0 2.28-.819l.923-1.597a1.875 1.875 0 0 0-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.6 7.6 0 0 0 0-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 0 0-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.5 7.5 0 0 0-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 0 0-1.85-1.567zM12 15.75a3.75 3.75 0 1 0 0-7.5a3.75 3.75 0 0 0 0 7.5"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-cog-6-tooth">
        <g
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5">
          <path
            d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87q.11.06.22.127c.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a8 8 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a7 7 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a7 7 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a7 7 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124q.108-.066.22-.128c.332-.183.582-.495.644-.869z" />
          <path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0" />
        </g>
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-cog-solid">
        <g fill="currentColor">
          <path
            d="M17.004 10.407c.138.435-.216.842-.672.842h-3.465a.75.75 0 0 1-.65-.375l-1.732-3c-.229-.396-.053-.907.393-1.004a5.25 5.25 0 0 1 6.126 3.537M8.12 8.464c.307-.338.838-.235 1.066.16l1.732 3a.75.75 0 0 1 0 .75l-1.732 3c-.229.397-.76.5-1.067.161A5.23 5.23 0 0 1 6.75 12a5.23 5.23 0 0 1 1.37-3.536m2.758 8.666c-.447-.098-.623-.608-.394-1.004l1.733-3.002a.75.75 0 0 1 .65-.375h3.465c.457 0 .81.407.672.842a5.25 5.25 0 0 1-6.126 3.539" />
          <path
            fill-rule="evenodd"
            d="M21 12.75a.75.75 0 1 0 0-1.5h-.783a8 8 0 0 0-.237-1.357l.734-.267a.75.75 0 1 0-.513-1.41l-.735.268a8 8 0 0 0-.689-1.192l.6-.503a.75.75 0 1 0-.964-1.149l-.6.504a8.3 8.3 0 0 0-1.054-.885l.391-.678a.75.75 0 1 0-1.299-.75l-.39.676a8 8 0 0 0-1.295-.47l.136-.77a.75.75 0 0 0-1.477-.26l-.136.77a8.4 8.4 0 0 0-1.377 0l-.136-.77a.75.75 0 1 0-1.477.26l.136.77q-.673.183-1.294.47l-.39-.676a.75.75 0 0 0-1.3.75l.392.678a8.3 8.3 0 0 0-1.054.885l-.6-.504a.75.75 0 1 0-.965 1.149l.6.503a8 8 0 0 0-.689 1.192L3.8 8.216a.75.75 0 1 0-.513 1.41l.735.267a8 8 0 0 0-.238 1.356h-.783a.75.75 0 0 0 0 1.5h.783q.063.697.238 1.356l-.735.268a.75.75 0 0 0 .513 1.41l.735-.268q.296.627.69 1.191l-.6.504a.75.75 0 0 0 .963 1.15l.601-.505q.49.486 1.054.885l-.392.68a.75.75 0 0 0 1.3.75l.39-.679q.622.289 1.294.471l-.136.77a.75.75 0 0 0 1.477.261l.137-.772a8.3 8.3 0 0 0 1.376 0l.136.772a.75.75 0 1 0 1.477-.26l-.136-.771a8 8 0 0 0 1.294-.47l.391.677a.75.75 0 0 0 1.3-.75l-.393-.679a8.3 8.3 0 0 0 1.054-.885l.601.504a.75.75 0 0 0 .964-1.15l-.6-.503q.392-.564.69-1.191l.735.267a.75.75 0 1 0 .512-1.41l-.734-.267q.173-.66.237-1.356zm-2.657-3.06l-.016-.05a6.7 6.7 0 0 0-1.174-2.002a6.8 6.8 0 0 0-1.82-1.51A6.7 6.7 0 0 0 12 5.248a7 7 0 0 0-1.225.11a6.7 6.7 0 0 0-2.15.793A6.8 6.8 0 0 0 5.673 9.64a1 1 0 0 1-.036.098A6.7 6.7 0 0 0 5.251 12a6.74 6.74 0 0 0 3.366 5.842l.009.005l.02.012a6.7 6.7 0 0 0 2.159.785l.024.004l.021.005a6.8 6.8 0 0 0 2.346-.008a6.7 6.7 0 0 0 2.205-.812a6.8 6.8 0 0 0 1.762-1.484l.009-.01l.009-.01a6.7 6.7 0 0 0 1.18-2.065c.253-.708.39-1.47.39-2.264a6.7 6.7 0 0 0-.408-2.309"
            clip-rule="evenodd" />
        </g>
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-cog">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M4.5 12a7.5 7.5 0 0 0 15 0m-15 0a7.5 7.5 0 1 1 15 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077l1.41-.513m14.095-5.13l1.41-.513M5.106 17.785l1.15-.964m11.49-9.642l1.149-.964M7.501 19.795l.75-1.3m7.5-12.99l.75-1.3m-6.063 16.658l.26-1.477m2.605-14.772l.26-1.477m0 17.726l-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205L12 12m6.894 5.785l-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864l-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-exclamation-circle-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12M12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75m0 8.25a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-bell">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M14.857 17.082a24 24 0 0 0 5.454-1.31A8.97 8.97 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.97 8.97 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.3 24.3 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-exclamation-circle">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M12 9v3.75m9-.75a9 9 0 1 1-18 0a9 9 0 0 1 18 0m-9 3.75h.008v.008H12z" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-bell-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M5.25 9a6.75 6.75 0 0 1 13.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206c-1.544.57-3.16.99-4.831 1.243q.01.14.01.281a3.75 3.75 0 1 1-7.49-.28a24.6 24.6 0 0 1-4.831-1.244a.75.75 0 0 1-.298-1.206A8.22 8.22 0 0 0 5.25 9.75zm4.502 8.9l-.002.1a2.25 2.25 0 1 0 4.498-.1a25 25 0 0 1-4.496 0"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-exclamation-triangle-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5zM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75m0 8.25a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-exclamation-triangle">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0zM12 15.75h.007v.008H12z" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-face-frown-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m-2.625 6c-.54 0-.828.419-.936.634a1.96 1.96 0 0 0-.189.866c0 .298.059.605.189.866c.108.215.395.634.936.634c.54 0 .828-.419.936-.634c.13-.26.189-.568.189-.866s-.059-.605-.189-.866c-.108-.215-.395-.634-.936-.634m4.314.634c.108-.215.395-.634.936-.634c.54 0 .828.419.936.634c.13.26.189.568.189.866s-.059.605-.189.866c-.108.215-.395.634-.936.634c-.54 0-.828-.419-.936-.634a1.96 1.96 0 0 1-.189-.866c0-.298.059-.605.189-.866m-4.34 7.964a.75.75 0 0 1-1.061-1.06a5.24 5.24 0 0 1 3.73-1.538a5.24 5.24 0 0 1 3.695 1.538a.75.75 0 1 1-1.061 1.06a3.74 3.74 0 0 0-2.639-1.098a3.74 3.74 0 0 0-2.664 1.098"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-face-frown">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M15.182 16.318A4.5 4.5 0 0 0 12.016 15a4.5 4.5 0 0 0-3.198 1.318M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0M9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75S9.168 9 9.375 9s.375.336.375.75m-.375 0h.008v.015h-.008zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75s.168-.75.375-.75s.375.336.375.75m-.375 0h.008v.015h-.008z" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-face-smile-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m-2.625 6c-.54 0-.828.419-.936.634a1.96 1.96 0 0 0-.189.866c0 .298.059.605.189.866c.108.215.395.634.936.634c.54 0 .828-.419.936-.634c.13-.26.189-.568.189-.866s-.059-.605-.189-.866c-.108-.215-.395-.634-.936-.634m4.314.634c.108-.215.395-.634.936-.634c.54 0 .828.419.936.634c.13.26.189.568.189.866s-.059.605-.189.866c-.108.215-.395.634-.936.634c-.54 0-.828-.419-.936-.634a1.96 1.96 0 0 1-.189-.866c0-.298.059-.605.189-.866m2.023 6.828a.75.75 0 1 0-1.06-1.06a3.75 3.75 0 0 1-5.304 0a.75.75 0 0 0-1.06 1.06a5.25 5.25 0 0 0 7.424 0"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-face-smile">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0M9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75S9.168 9 9.375 9s.375.336.375.75m-.375 0h.008v.015h-.008zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75s.168-.75.375-.75s.375.336.375.75m-.375 0h.008v.015h-.008z" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-fire-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M12.963 2.286a.75.75 0 0 0-1.071-.136a9.74 9.74 0 0 0-3.539 6.176a7.6 7.6 0 0 1-1.705-1.715a.75.75 0 0 0-1.152-.082A9 9 0 1 0 15.68 4.534a7.46 7.46 0 0 1-2.717-2.248M15.75 14.25a3.75 3.75 0 1 1-7.313-1.172c.628.465 1.35.81 2.133 1a6 6 0 0 1 1.925-3.546a3.75 3.75 0 0 1 3.255 3.718"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-fire">
        <g
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5">
          <path
            d="M15.362 5.214A8.252 8.252 0 0 1 12 21A8.25 8.25 0 0 1 6.038 7.047A8.3 8.3 0 0 0 9 9.601a8.98 8.98 0 0 1 3.361-6.867a8.2 8.2 0 0 0 3 2.48" />
          <path
            d="M12 18a3.75 3.75 0 0 0 .495-7.468a6 6 0 0 0-1.925 3.547a6 6 0 0 1-2.133-1.001A3.75 3.75 0 0 0 12 18" />
        </g>
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-globe-alt-solid">
        <path
          fill="currentColor"
          d="M21.721 12.752q.03-.373.029-.752c0-1.524-.35-2.967-.973-4.252a12.8 12.8 0 0 1-4.34 2.709a19 19 0 0 1-.214 4.772a17.2 17.2 0 0 0 5.498-2.477m-7.087 2.798a17.3 17.3 0 0 0 .332-4.647c-.952.227-1.945.347-2.966.347s-2.014-.12-2.966-.347a17.5 17.5 0 0 0 .332 4.647a17.4 17.4 0 0 0 5.268 0m-4.862 1.569a19 19 0 0 0 4.456 0A17.2 17.2 0 0 1 12 21.724a17.2 17.2 0 0 1-2.228-4.605M7.777 15.23a19 19 0 0 1-.214-4.773a12.8 12.8 0 0 1-4.34-2.709a9.7 9.7 0 0 0-.944 5.004a17.2 17.2 0 0 0 5.498 2.477m13.579-.476a9.77 9.77 0 0 1-7.478 6.816a18.6 18.6 0 0 0 1.988-4.718a18.6 18.6 0 0 0 5.49-2.098m-18.712 0c1.682.97 3.53 1.687 5.49 2.098a18.6 18.6 0 0 0 1.988 4.718a9.77 9.77 0 0 1-7.478-6.816M13.878 2.43a9.76 9.76 0 0 1 6.116 3.986a11.3 11.3 0 0 1-3.746 2.504a18.6 18.6 0 0 0-2.37-6.49M12 2.276a17.15 17.15 0 0 1 2.805 7.121a11.3 11.3 0 0 1-5.61 0A17.15 17.15 0 0 1 12 2.276m-1.878.154a18.6 18.6 0 0 0-2.37 6.49a11.3 11.3 0 0 1-3.746-2.504a9.75 9.75 0 0 1 6.116-3.985" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-globe-alt">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a9 9 0 0 1 7.843 4.582M12 3a9 9 0 0 0-7.843 4.582m15.686 0A11.95 11.95 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.96 8.96 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.9 17.9 0 0 1 12 16.5a17.9 17.9 0 0 1-8.716-2.247m0 0A9 9 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-globe-americas-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M6.262 6.072a8.25 8.25 0 1 0 10.562-.766a4.5 4.5 0 0 1-1.318 1.357L14.25 7.5l.165.33a.809.809 0 0 1-1.086 1.085l-.604-.302a1.125 1.125 0 0 0-1.298.21l-.132.131a1.127 1.127 0 0 0 0 1.592l.296.295c.256.257.622.374.98.314l1.17-.195c.323-.054.654.036.905.245l1.33 1.108c.32.267.46.694.358 1.1a8.7 8.7 0 0 1-2.288 4.04l-.723.724a1.125 1.125 0 0 1-1.298.21l-.153-.076a1.13 1.13 0 0 1-.622-1.006v-1.089c0-.298-.119-.585-.33-.796l-1.347-1.347a1.125 1.125 0 0 1-.21-1.298L9.75 12l-1.64-1.64a6 6 0 0 1-1.676-3.257z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-globe-americas">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m6.115 5.19l.319 1.913A6 6 0 0 0 8.11 10.36L9.75 12l-.387.775c-.217.433-.132.956.21 1.298l1.348 1.348c.21.21.329.497.329.795v1.089c0 .426.24.815.622 1.006l.153.076c.433.217.956.132 1.298-.21l.723-.723a8.7 8.7 0 0 0 2.288-4.042a1.09 1.09 0 0 0-.358-1.099l-1.33-1.108a1.12 1.12 0 0 0-.905-.245l-1.17.195a1.13 1.13 0 0 1-.98-.314l-.295-.295a1.125 1.125 0 0 1 0-1.591l.13-.132a1.125 1.125 0 0 1 1.3-.21l.603.302a.809.809 0 0 0 1.086-1.086L14.25 7.5l1.256-.837a4.5 4.5 0 0 0 1.528-1.732l.146-.292M6.115 5.19a9 9 0 1 0 11.065-.55m-11.065.55A8.97 8.97 0 0 1 12 3c1.929 0 3.716.607 5.18 1.64" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-globe-asia-australia-solid">
        <g fill="currentColor">
          <path
            d="M15.75 8.25a.75.75 0 0 1 .75.75a3.74 3.74 0 0 1-1.27 2.812a.75.75 0 1 1-.992-1.124A2.24 2.24 0 0 0 15 9a.75.75 0 0 1 .75-.75" />
          <path
            fill-rule="evenodd"
            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M4.575 15.6a8.25 8.25 0 0 0 9.348 4.425a1.97 1.97 0 0 0-1.84-1.275a.98.98 0 0 1-.97-.822l-.073-.437c-.094-.565.25-1.11.8-1.267l.99-.282c.427-.123.783-.418.982-.816l.036-.073a1.453 1.453 0 0 1 2.328-.377L16.5 15h.628a2.25 2.25 0 0 1 1.983 1.186a8.25 8.25 0 0 0-6.345-12.4c.044.262.18.503.389.676l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 0 1-1.161.886l-.143.048a1.107 1.107 0 0 0-.57 1.664a1.108 1.108 0 0 1-.427 1.605L9 13.125l.423 1.059a.956.956 0 0 1-1.652.928l-.679-.906a1.125 1.125 0 0 0-1.906.172z"
            clip-rule="evenodd" />
        </g>
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-globe-asia-australia">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M12.75 3.03v.568c0 .334.148.65.405.864l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 0 1-1.161.886l-.143.048a1.107 1.107 0 0 0-.57 1.664a1.108 1.108 0 0 1-.427 1.605L9 13.125l.423 1.059a.956.956 0 0 1-1.652.928l-.679-.906a1.125 1.125 0 0 0-1.906.172L4.5 15.75l-.612.153M12.75 3.031a9 9 0 0 0-8.862 12.872M12.75 3.031a9 9 0 0 1 6.69 14.036m0 0l-.177-.529A2.25 2.25 0 0 0 17.128 15H16.5l-.324-.324a1.453 1.453 0 0 0-2.328.377l-.036.073a1.6 1.6 0 0 1-.982.816l-.99.282c-.55.157-.894.702-.8 1.267l.073.438c.08.474.49.821.97.821c.846 0 1.598.542 1.865 1.345l.215.643m5.276-3.67a9 9 0 0 1-5.276 3.67m0 0a9 9 0 0 1-10.275-4.835M15.75 9c0 .896-.393 1.7-1.016 2.25" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-globe-europe-africa-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M8.547 4.505a8.25 8.25 0 1 0 11.672 8.214l-.46-.46a2.3 2.3 0 0 1-.422-.586l-1.08-2.16a.414.414 0 0 0-.663-.107a.83.83 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.211.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025a1.055 1.055 0 0 1-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.654-.261a2.25 2.25 0 0 1-1.384-2.46l.007-.042a2.3 2.3 0 0 1 .29-.787l.09-.15a2.25 2.25 0 0 1 2.37-1.048l1.178.236a1.125 1.125 0 0 0 1.302-.795l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332l-.091.091a2.25 2.25 0 0 1-1.591.659h-.18a.94.94 0 0 0-.662.274a.931.931 0 0 1-1.458-1.137z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-globe-europe-africa">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m20.893 13.393l-1.135-1.135a2.3 2.3 0 0 1-.421-.585l-1.08-2.16a.414.414 0 0 0-.663-.107a.83.83 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025a1.055 1.055 0 0 1-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 0 1-1.383-2.46l.007-.042a2.3 2.3 0 0 1 .29-.787l.09-.15a2.25 2.25 0 0 1 2.37-1.048l1.178.236a1.125 1.125 0 0 0 1.302-.795l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332l-.091.091a2.25 2.25 0 0 1-1.591.659h-.18a.94.94 0 0 0-.662.274a.931.931 0 0 1-1.458-1.137l1.411-2.353a2.3 2.3 0 0 0 .286-.76m11.928 9.869Q20.999 12.71 21 12A9 9 0 0 0 8.965 3.525m11.928 9.868A9 9 0 1 1 8.965 3.525" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-hand-raised-solid">
        <path
          fill="currentColor"
          d="M10.5 1.875a1.125 1.125 0 0 1 2.25 0v8.219c.517.162 1.02.382 1.5.659V3.375a1.125 1.125 0 0 1 2.25 0v10.937a4.5 4.5 0 0 0-3.25 2.373a8.96 8.96 0 0 1 4-.935A.75.75 0 0 0 18 15v-2.266a3.37 3.37 0 0 1 .988-2.37a1.125 1.125 0 0 1 1.592 1.59a1.12 1.12 0 0 0-.33.79v3.006h-.005a6 6 0 0 1-1.752 4.007l-1.736 1.736a6 6 0 0 1-4.242 1.757H10.5a7.5 7.5 0 0 1-7.5-7.5V6.375a1.125 1.125 0 0 1 2.25 0v5.519c.46-.452.965-.832 1.5-1.141V3.375a1.125 1.125 0 0 1 2.25 0v6.526q.744-.15 1.5-.151z" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-hand-thumb-down-solid">
        <path
          fill="currentColor"
          d="M15.73 5.5h1.035A7.47 7.47 0 0 1 18 9.625a7.47 7.47 0 0 1-1.235 4.125h-.148c-.806 0-1.533.446-2.031 1.08a9 9 0 0 1-2.861 2.4c-.723.384-1.35.956-1.653 1.715a4.5 4.5 0 0 0-.322 1.672v.633A.75.75 0 0 1 9 22a2.25 2.25 0 0 1-2.25-2.25c0-1.152.26-2.243.723-3.218c.266-.558-.107-1.282-.725-1.282H3.622c-1.026 0-1.945-.694-2.054-1.715A12 12 0 0 1 1.5 12.25c0-2.848.992-5.464 2.649-7.521C4.537 4.247 5.136 4 5.754 4H9.77a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23m5.939 8.523c.536-1.362.831-2.845.831-4.398c0-1.22-.182-2.398-.52-3.507c-.26-.85-1.084-1.368-1.973-1.368H19.1c-.445 0-.72.498-.523.898c.591 1.2.924 2.55.924 3.977a8.96 8.96 0 0 1-1.302 4.666c-.245.403.028.959.5.959h1.053c.832 0 1.612-.453 1.918-1.227" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-hand-thumb-down">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M7.498 15.25H4.372c-1.026 0-1.945-.694-2.054-1.715a12 12 0 0 1-.068-1.285c0-2.848.992-5.464 2.649-7.521C5.287 4.247 5.886 4 6.504 4h4.016a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23h1.294M7.499 15.25c.618 0 .991.724.725 1.282A7.5 7.5 0 0 0 7.5 19.75A2.25 2.25 0 0 0 9.75 22a.75.75 0 0 0 .75-.75v-.633c0-.573.11-1.14.322-1.672c.304-.76.93-1.33 1.653-1.715a9 9 0 0 0 2.86-2.4c.498-.634 1.226-1.08 2.032-1.08h.384m-10.253 1.5H9.7m8.075-9.75q.015.075.05.148a8.95 8.95 0 0 1 .925 3.977a8.95 8.95 0 0 1-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368c.339 1.11.521 2.287.521 3.507c0 1.553-.295 3.036-.831 4.398c-.306.774-1.086 1.227-1.918 1.227h-1.053c-.472 0-.745-.556-.5-.96a9 9 0 0 0 .303-.54" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-hand-thumb-up-solid">
        <path
          fill="currentColor"
          d="M7.493 18.5c-.425 0-.82-.236-.975-.632A7.5 7.5 0 0 1 6 15.125a7.47 7.47 0 0 1 1.602-4.634c.151-.192.373-.309.6-.397c.473-.183.89-.514 1.212-.924a9 9 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.5 4.5 0 0 0 .322-1.672V2.75A.75.75 0 0 1 15 2a2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218c-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715q.068.633.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H14.23a4.5 4.5 0 0 1-1.423-.23l-3.114-1.04a4.5 4.5 0 0 0-1.423-.23zm-5.162-7.773a12 12 0 0 0-.831 4.398a12 12 0 0 0 .52 3.507C2.28 19.482 3.105 20 3.994 20H4.9c.445 0 .72-.498.523-.898a9 9 0 0 1-.924-3.977c0-1.708.476-3.305 1.302-4.666c.245-.403-.028-.959-.5-.959H4.25c-.832 0-1.612.453-1.918 1.227" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-hand-thumb-up">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M6.633 10.25c.806 0 1.533-.446 2.031-1.08a9 9 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.5 4.5 0 0 0 .322-1.672V2.75a.75.75 0 0 1 .75-.75a2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218c-.266.558.107 1.282.725 1.282m0 0h3.126c1.026 0 1.945.694 2.054 1.715q.068.633.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H13.48a4.5 4.5 0 0 1-1.423-.23l-3.114-1.04a4.5 4.5 0 0 0-1.423-.23H5.904m10.598-9.75H14.25M5.904 18.5q.125.307.27.602c.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 0 1-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 9.953 4.167 9.5 5 9.5h1.053c.472 0 .745.556.5.96a8.96 8.96 0 0 0-1.302 4.665a9 9 0 0 0 .654 3.375" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-heart-solid">
        <path
          fill="currentColor"
          d="m11.645 20.91l-.007-.003l-.022-.012l-.082-.045q-.108-.06-.301-.173a25.2 25.2 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25C2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052A5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25c0 3.925-2.438 7.111-4.739 9.256a25 25 0 0 1-4.244 3.17a15 15 0 0 1-.383.219l-.022.012l-.007.004l-.003.001a.75.75 0 0 1-.704 0z" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-heart">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M21 8.25c0-2.485-2.099-4.5-4.687-4.5c-1.936 0-3.598 1.126-4.313 2.733c-.715-1.607-2.377-2.733-4.312-2.733C5.098 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-information-circle-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12m8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836l.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836l-.042.02a.75.75 0 1 1-.671-1.34zM12 9a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-information-circle">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m11.25 11.25l.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0m-9-3.75h.008v.008H12z" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        id="heroicons-inbox-arrow-down">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M9 3.75H6.912a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859M12 3v8.25m0 0-3-3m3 3 3-3" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-lock-closed-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25m3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-lock-closed">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-paper-clip-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M18.97 3.659a2.25 2.25 0 0 0-3.182 0l-10.94 10.94a3.75 3.75 0 1 0 5.304 5.303l7.693-7.693a.75.75 0 0 1 1.06 1.06l-7.693 7.693a5.25 5.25 0 1 1-7.424-7.424l10.939-10.94a3.75 3.75 0 1 1 5.303 5.304L9.097 18.835l-.008.008l-.007.007l-.002.002l-.003.002A2.25 2.25 0 0 1 5.91 15.66l7.81-7.81a.75.75 0 0 1 1.061 1.06l-7.81 7.81a.75.75 0 0 0 1.054 1.068L18.97 6.84a2.25 2.25 0 0 0 0-3.182"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-paper-clip">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m18.375 12.739l-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-plus-small">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M12 6v12m6-6H6" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-plus">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M12 4.5v15m7.5-7.5h-15" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-question-mark-circle-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12m11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 0 1-.988-1.129c1.454-1.272 3.776-1.272 5.23 0c1.513 1.324 1.513 3.518 0 4.842a3.8 3.8 0 0 1-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 0 1-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502q.274-.133.503-.331c.83-.727.83-1.857 0-2.584M12 18a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5"
          clip-rule="evenodd" />
      </symbol>

      <symbol
        viewBox="0 0 24 24"
        id="heroicons-question-mark-circle">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M9.879 7.519c1.172-1.025 3.071-1.025 4.243 0c1.171 1.025 1.171 2.687 0 3.712q-.308.268-.67.442c-.746.361-1.452.999-1.452 1.827v.75M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0m-9 5.25h.008v.008H12z" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-shield-check-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M12.516 2.17a.75.75 0 0 0-1.032 0a11.2 11.2 0 0 1-7.877 3.08a.75.75 0 0 0-.722.515A12.7 12.7 0 0 0 2.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.75.75 0 0 0 .374 0c5.499-1.415 9.563-6.406 9.563-12.348c0-1.39-.223-2.73-.635-3.985a.75.75 0 0 0-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08m3.094 8.016a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-shield-check">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M9 12.75L11.25 15L15 9.75m-3-7.036A11.96 11.96 0 0 1 3.598 6A12 12 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623c5.176-1.332 9-6.03 9-11.622c0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-shield-exclamation-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M11.484 2.17a.75.75 0 0 1 1.032 0a11.2 11.2 0 0 0 7.877 3.08a.75.75 0 0 1 .722.515a12.7 12.7 0 0 1 .635 3.985c0 5.942-4.064 10.933-9.563 12.348a.75.75 0 0 1-.374 0C6.314 20.683 2.25 15.692 2.25 9.75c0-1.39.223-2.73.635-3.985a.75.75 0 0 1 .722-.516l.143.001c2.996 0 5.718-1.17 7.734-3.08M12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75M12 15a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75v-.008a.75.75 0 0 0-.75-.75z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-shield-exclamation">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M12 9v3.75m0-10.036A11.96 11.96 0 0 1 3.598 6A12 12 0 0 0 3 9.75c0 5.592 3.824 10.29 9 11.622c5.176-1.332 9-6.03 9-11.622c0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.25-8.25-3.286m0 13.036h.008v.008H12z" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-trash-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M16.5 4.478v.227a49 49 0 0 1 3.878.512a.75.75 0 1 1-.256 1.478l-.209-.035l-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A49 49 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a53 53 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951m-6.136-1.452a51 51 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a50 50 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452m-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058z"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-trash">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21q.512.078 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48 48 0 0 0-3.478-.397m-12 .562q.51-.088 1.022-.165m0 0a48 48 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a52 52 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a49 49 0 0 0-7.5 0" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-x-mark-solid">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12L5.47 6.53a.75.75 0 0 1 0-1.06"
          clip-rule="evenodd" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-x-mark">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M6 18L18 6M6 6l12 12" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        fill="none"
        id="heroicons-paint-brush">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M9.53 16.122a3 3 0 0 0-5.78 1.128 2.25 2.25 0 0 1-2.4 2.245 4.5 4.5 0 0 0 8.4-2.245c0-.399-.078-.78-.22-1.128Zm0 0a15.998 15.998 0 0 0 3.388-1.62m-5.043-.025a15.994 15.994 0 0 1 1.622-3.395m3.42 3.42a15.995 15.995 0 0 0 4.764-4.648l3.876-5.814a1.151 1.151 0 0 0-1.597-1.597L14.146 6.32a15.996 15.996 0 0 0-4.649 4.763m3.42 3.42a6.776 6.776 0 0 0-3.42-3.42" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-pencil">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m16.862 4.487l1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8l.8-2.685a4.5 4.5 0 0 1 1.13-1.897zm0 0L19.5 7.125" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-pencil-square">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="m16.862 4.487l1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        id="heroicons-key">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25" />
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        fill="currentColor"
        id="heroicons-puzzle-piece-solid">
        <path d="M11.25 5.337c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.036 1.007-1.875 2.25-1.875S15 2.34 15 3.375c0 .369-.128.713-.349 1.003-.215.283-.401.604-.401.959 0 .332.278.598.61.578 1.91-.114 3.79-.342 5.632-.676a.75.75 0 0 1 .878.645 49.17 49.17 0 0 1 .376 5.452.657.657 0 0 1-.66.664c-.354 0-.675-.186-.958-.401a1.647 1.647 0 0 0-1.003-.349c-1.035 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401.31 0 .557.262.534.571a48.774 48.774 0 0 1-.595 4.845.75.75 0 0 1-.61.61c-1.82.317-3.673.533-5.555.642a.58.58 0 0 1-.611-.581c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.035-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959a.641.641 0 0 1-.658.643 49.118 49.118 0 0 1-4.708-.36.75.75 0 0 1-.645-.878c.293-1.614.504-3.257.629-4.924A.53.53 0 0 0 5.337 15c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.036 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.369 0 .713.128 1.003.349.283.215.604.401.959.401a.656.656 0 0 0 .659-.663 47.703 47.703 0 0 0-.31-4.82.75.75 0 0 1 .83-.832c1.343.155 2.703.254 4.077.294a.64.64 0 0 0 .657-.642Z"/>
      </symbol>
      <symbol
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        id="heroicons-puzzle-piece">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 0 1-.657.643 48.39 48.39 0 0 1-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 0 1-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 0 0-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 0 1-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 0 0 .657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 0 0 5.427-.63 48.05 48.05 0 0 0 .582-4.717.532.532 0 0 0-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 0 0 .658-.663 48.422 48.422 0 0 0-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 0 1-.61-.58v0Z"/>
      </symbol>
    </defs>
  </svg>
</template>
<!-- SVG fill behavior:
  fill=""         -> black (#000000) - same as default
  fill="none"     -> transparent, cannot animate, allows stroke
  fill="transparent" -> transparent, can animate
  [not defined]   -> black (#000000) - default behavior
  fill="currentColor" -> inherits parent CSS color property
  fill="initial"  -> resets to black (#000000)
  fill="inherit"  -> inherits parent SVG fill value
  fill="red"      -> named colors
  fill="#ff0000"  -> hex colors
  fill="rgb(255,0,0)" -> RGB colors
  fill="rgba(255,0,0,0.5)" -> RGBA with opacity
  fill="hsl(0,100%,50%)" -> HSL colors
  fill="url(#gradientId)" -> pattern/gradient references
  fill="Canvas"   -> system colors

  Precedence: explicit > inherited > default black
-->
